import { getUrlParam } from "./url";

export function getPlayerSessionId() {
    // get localhost session
    if (!getUrlParam('playerSessionId')) {
        const url = `https://operator-api.dev.goosicorn.dev/operator/player/register`;
        const operatorPlayerId = `player-${Math.floor(Math.random() * 10000)}`;

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic bXJxOjEyMzQ1Njc4',
            },
            body: JSON.stringify({
                operatorId: 'dummy-operator',
                operatorPlayerId,
                country: 'uk',
                currency: 'gbp',
                jurisdiction: 'ukgc',
            }),
        })
            .then((response) => response.json())
            .then(async (json) => {
                let url = `server=https://connector.dev.goosicorn.dev/multigame`;
                url += `&gameId=${GAME_ID}`;
                url += `&userRef=${json.playerSessionData.userRef}`;
                url += `&playerSessionId=${json.playerSessionData.playerSessionId}`;
                url += `&accountType=PRACTICE`;
                url += `&stomp`;

                document.location = `?${url}`;
            });
    }
}